<template>
  <footer class="foot">
    <div class="foot-head">
      <div class="foot-row">
        <logo></logo>
      </div>
    </div>
    <div class="foot-body">
      <div class="foot-row foot-body__inner">
        <div class="foot-col foot-col-1">
          <div class="foot-cell">
            <span><strong>Dagens Næringsliv AS</strong></span>
          </div>
          <div class="foot-cell">
            <span>Sjefredaktør/Adm.dir</span><span>:</span> <span><strong>Amund Djuve</strong></span>
          </div>

          <div class="foot-cell">
            <span>Sentralbord DN</span><span>:</span> <a href="tel:+4722001000">22 00 10 00</a>
          </div>
          <div class="foot-cell">
            <span>Kundeservice</span><span>:</span> <a href="tel:+4721896100">21 89 61 00</a>
          </div>
          <div class="foot-cell">
            <span class="foot-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 14" width="100%" height="100%"><path fill-rule="evenodd" d="M4.581 3.507L1.25 6.764 0 5.379 5.5 0 11 5.379 9.75 6.764 6.407 3.493V14H4.581z"></path></svg></span>
            <a href="https://www.dn.no/kundeservice/kontakt">Kontakt kundeservice</a>
          </div>
          <div class="foot-cell">
            <span>&nbsp;</span>
          </div>
          <div class="foot-cell">
            <span>Vakthavende redaktør</span><span>:</span> <a href="tel:+4722001003">22 00 10 03</a>
          </div>
          <div class="foot-cell">
            <a href="mailto:utgavesjef@dn.no">utgavesjef@dn.no</a>
          </div>
          <div class="foot-cell">
            <span>&nbsp;</span>
          </div>
          <div class="foot-cell">
            <span>Redaksjonen</span><span>:</span> <a href="tel:+4722001000">22 00 10 00</a>
          </div>
          <div class="foot-cell">
            <a href="mailto:tips@dn.no">tips@dn.no</a>
          </div>
        </div>

        <div class="foot-col foot-col-2">
          <div class="foot-cell">
            <span>Postadresse:</span>
          </div>
          <div class="foot-cell">
            <span><strong>Postboks 1182 Sentrum</strong></span>
          </div>
          <div class="foot-cell">
            <span><strong>0107 Oslo</strong></span>
          </div>
          <div class="foot-cell">
            <span>&nbsp;</span>
          </div>
          <div class="foot-cell">
            <span>Besøksadresse:</span>
          </div>
          <div class="foot-cell">
            <span><strong>Christian Krohgs gate 16</strong></span>
          </div>
          <div class="foot-cell">
            <span><strong>0186 Oslo</strong></span>
          </div>
          <div class="foot-cell">
            <span>&nbsp;</span>
          </div>
          <div class="foot-cell">
            <span>Tilsynsmyndighet: <strong>Medietilsynet</strong></span>
          </div>
        </div>
      </div>

      <div class="foot-row foot-links">
        <ul class="foot-items">
          <li class="foot-item" :key="i" v-for="(item, i) in links">
            <a v-if="item.href" :href="item.href">{{item.value}}</a>
            <span v-else v-html="item.value"></span>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
  import Logo from './Logo';

  export default {
    components: {
      Logo,
    },
    data() {
      return {
        links: [
          {
            href: 'https://www.dn.no/kundeservice',
            value: 'Kundeservice',
          },
          {
            href: 'https://www.dn.no/kundeservice/min-side',
            value: 'Min side',
          },
          {
            href: 'https://www.dn.no/idn',
            value: 'Annonse',
          },
          {
            href: 'https://www.dn.no/avis/arkiv',
            value: 'Arkiv',
          },
          {
            href: 'https://www.dn.no/kundeservice/faq/vilkar-og-personvern/personvern',
            value: 'Personvern',
          },
          {
            href: 'https://www.dn.no/kundeservice/faq/vilkar-og-personvern/cookies',
            value: 'Cookies',
          },
          {
            href: 'https://www.dn.no/info/2014/01/20/1427/vilkar-for-bruk-av-dnno',
            value: 'Vilkår',
          },
          {
            href: 'https://candidate.hr-manager.net/Vacancies/List.aspx?customer=nhst&departmentid=18995&mediaid=4643',
            value: 'Jobb i DN',
          },
          {
            href: 'https://www.dn.no/info/rss/',
            value: 'RSS',
          },
          {
            href: 'https://www.dn.no/',
            value: 'Til Forsiden',
          },
        ],
      };
    },
  }
</script>

<style lang="scss">
  @import 'scss/dn/base';

  .foot {
    background-color: $color-dn-footer-dark-blue;
    border-bottom: 0.5rem solid $color-dn-footer-blue;
    border-top: 0.5rem solid $color-dn-footer-blue;
    color: $color-white;
    font-family: $font-guardian-sans, sans-serif;
    font-size: 1rem;
    font-weight: 300;
    line-height: 21px;
    position: relative;
    width: 100%;

    .logo-link {
      display: inline-block;
      padding: 0;
    }

    .logo-path-letters {
      display: none;

      @media #{$grid-md-up} {
        display: block;
      }
    }

    .logo-svg {
      filter: none;
      height: 37px;
      max-width: 148px;
      position: relative;
      top: 4px;
    }

    .logo-path-letters path {
      fill: #fff;
    }

    .logo-path-dn path {
      fill: #fff;
    }

    a, strong {
      color: $color-white;
      font-weight: 700;
    }

    .spacer {
      display: block;
      line-height: 10px;
    }
  }

  .foot-head {
    padding: 10px 0;
    display: flex;
    align-items: center;
    height: 60px;
  }

  .foot-body {
    padding: 0 0 1.25rem;
  }

  .foot-body__inner {
    display: flex;
    flex-wrap: wrap;
    padding: 25px 0;
  }

  .foot-col {
    width: 100%;
    padding-top: 25px;


    &:first-of-type {
      padding-right: 15px;
    }

    @media #{$grid-md-up} {
      width: 33.33%;
    }
  }

  .foot-row {
    @include row-dn;
  }

  .foot-col-1,
  .foot-col-2 {
    a[href^='tel'] {
      text-decoration: none;

      &:hover {
        text-decoration: none;
        color: #fff;
        opacity: .75;
      }
    }

    a[href^='http'],
    a[href^='mailto'] {
      text-decoration: underline;

      &:hover {
        text-decoration: none;
        color: #fff;
      }
    }
  }

  .foot-arrow {
    fill: $color-white;
    transform: rotate(90deg);
    width: 16px;
    height: 16px;
    display: inline-block;
    position: relative;
    top: 2px;
    margin-right: 5px;

    svg {
      display: block;
    }
  }

  .foot-links {
    padding-top: 25px;
  }

  .foot-items {
    list-style-type: none;
    margin: 0;
    padding: 0;
    border-top: 0.125rem solid $color-dn-footer-blue;
  }

  .foot-item {
    display: inline-block;
    margin-top: 16px;
    padding: 0 16px;
    margin-left: -15px;
    width: 50%;

    @media #{$grid-md-up} {
      width: auto;
    }

    @media #{$grid-lg-up} {
      margin-left: 0;

      &:first-of-type {
        padding-left: 0;
      }
    }

    a {
      color: $color-white;
      font-size: 0.875rem;
      font-weight: 400;

      &:hover,
      &:focus {
        color: $color-white;
        opacity: 1;
        text-decoration: underline;
      }
    }
  }
</style>